module.exports = __webpack_public_path__ + "static/media/feat_coffeeUnderground.0dd14a59.png";